import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9655cd28"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createBlock(_component_router_link, {
    to: $props.to || `/personalcollect/${$props.user.id}`,
    target: "_blank",
    class: "avatar-box"
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      class: "avatar",
      src: $props.user.logo || $props.user.photo || $data.defaultIcon
    }, null, 8, _hoisted_1), $props.user.certificateType ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["level", `levelbg${$props.user.certificateType}`])
    }, null, 2)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["to"]);
}